function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { invariant, pipe, clamp, millisecondsToSeconds, secondsToMilliseconds } from 'motion-utils';
import { time } from '../frameloop/sync-time.mjs';
import { activeAnimations } from '../stats/animation-count.mjs';
import { mix } from '../utils/mix/index.mjs';
import { frameloopDriver } from './drivers/frame.mjs';
import { inertia } from './generators/inertia.mjs';
import { keyframes } from './generators/keyframes.mjs';
import { calcGeneratorDuration } from './generators/utils/calc-duration.mjs';
import { getFinalKeyframe } from './keyframes/get-final.mjs';
import { replaceTransitionType } from './utils/replace-transition-type.mjs';
import { WithPromise } from './utils/WithPromise.mjs';

var percentToProgress = function percentToProgress(percent) {
  return percent / 100;
};

var JSAnimation = /*#__PURE__*/function (_WithPromise) {
  _inherits(JSAnimation, _WithPromise);

  var _super = _createSuper(JSAnimation);

  function JSAnimation(options) {
    var _this;

    _classCallCheck(this, JSAnimation);

    _this = _super.call(this);
    _this.state = "idle";
    _this.startTime = null;
    _this.isStopped = false;
    /**
     * The current time of the animation.
     */

    _this.currentTime = 0;
    /**
     * The time at which the animation was paused.
     */

    _this.holdTime = null;
    /**
     * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
     */

    _this.playbackSpeed = 1;
    /**
     * This method is bound to the instance to fix a pattern where
     * animation.stop is returned as a reference from a useEffect.
     */

    _this.stop = function () {
      var _this$options$onStop, _this$options;

      var motionValue = _this.options.motionValue;

      if (motionValue && motionValue.updatedAt !== time.now()) {
        _this.tick(time.now());
      }

      _this.isStopped = true;
      if (_this.state === "idle") return;

      _this.teardown();

      (_this$options$onStop = (_this$options = _this.options).onStop) === null || _this$options$onStop === void 0 ? void 0 : _this$options$onStop.call(_this$options);
    };

    activeAnimations.mainThread++;
    _this.options = options;

    _this.initAnimation();

    _this.play();

    if (options.autoplay === false) _this.pause();
    return _this;
  }

  _createClass(JSAnimation, [{
    key: "initAnimation",
    value: function initAnimation() {
      var options = this.options;
      replaceTransitionType(options);
      var _options$type = options.type,
          type = _options$type === void 0 ? keyframes : _options$type,
          _options$repeat = options.repeat,
          repeat = _options$repeat === void 0 ? 0 : _options$repeat,
          _options$repeatDelay = options.repeatDelay,
          repeatDelay = _options$repeatDelay === void 0 ? 0 : _options$repeatDelay,
          repeatType = options.repeatType,
          _options$velocity = options.velocity,
          velocity = _options$velocity === void 0 ? 0 : _options$velocity;
      var keyframes$1 = options.keyframes;
      var generatorFactory = type || keyframes;

      if (process.env.NODE_ENV !== "production" && generatorFactory !== keyframes) {
        invariant(keyframes$1.length <= 2, "Only two keyframes currently supported with spring and inertia animations. Trying to animate ".concat(keyframes$1));
      }

      if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
        this.mixKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
        keyframes$1 = [0, 100];
      }

      var generator = generatorFactory(_objectSpread(_objectSpread({}, options), {}, {
        keyframes: keyframes$1
      }));
      /**
       * If we have a mirror repeat type we need to create a second generator that outputs the
       * mirrored (not reversed) animation and later ping pong between the two generators.
       */

      if (repeatType === "mirror") {
        this.mirroredGenerator = generatorFactory(_objectSpread(_objectSpread({}, options), {}, {
          keyframes: _toConsumableArray(keyframes$1).reverse(),
          velocity: -velocity
        }));
      }
      /**
       * If duration is undefined and we have repeat options,
       * we need to calculate a duration from the generator.
       *
       * We set it to the generator itself to cache the duration.
       * Any timeline resolver will need to have already precalculated
       * the duration by this step.
       */


      if (generator.calculatedDuration === null) {
        generator.calculatedDuration = calcGeneratorDuration(generator);
      }

      var calculatedDuration = generator.calculatedDuration;
      this.calculatedDuration = calculatedDuration;
      this.resolvedDuration = calculatedDuration + repeatDelay;
      this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
      this.generator = generator;
    }
  }, {
    key: "updateTime",
    value: function updateTime(timestamp) {
      var animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed; // Update currentTime

      if (this.holdTime !== null) {
        this.currentTime = this.holdTime;
      } else {
        // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
      }
    }
  }, {
    key: "tick",
    value: function tick(timestamp) {
      var sample = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var generator = this.generator,
          totalDuration = this.totalDuration,
          mixKeyframes = this.mixKeyframes,
          mirroredGenerator = this.mirroredGenerator,
          resolvedDuration = this.resolvedDuration,
          calculatedDuration = this.calculatedDuration;
      if (this.startTime === null) return generator.next(0);
      var _this$options2 = this.options,
          _this$options2$delay = _this$options2.delay,
          delay = _this$options2$delay === void 0 ? 0 : _this$options2$delay,
          keyframes = _this$options2.keyframes,
          repeat = _this$options2.repeat,
          repeatType = _this$options2.repeatType,
          repeatDelay = _this$options2.repeatDelay,
          type = _this$options2.type,
          onUpdate = _this$options2.onUpdate,
          finalKeyframe = _this$options2.finalKeyframe;
      /**
       * requestAnimationFrame timestamps can come through as lower than
       * the startTime as set by performance.now(). Here we prevent this,
       * though in the future it could be possible to make setting startTime
       * a pending operation that gets resolved here.
       */

      if (this.speed > 0) {
        this.startTime = Math.min(this.startTime, timestamp);
      } else if (this.speed < 0) {
        this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
      }

      if (sample) {
        this.currentTime = timestamp;
      } else {
        this.updateTime(timestamp);
      } // Rebase on delay


      var timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
      var isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
      this.currentTime = Math.max(timeWithoutDelay, 0); // If this animation has finished, set the current time  to the total duration.

      if (this.state === "finished" && this.holdTime === null) {
        this.currentTime = totalDuration;
      }

      var elapsed = this.currentTime;
      var frameGenerator = generator;

      if (repeat) {
        /**
         * Get the current progress (0-1) of the animation. If t is >
         * than duration we'll get values like 2.5 (midway through the
         * third iteration)
         */
        var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
        /**
         * Get the current iteration (0 indexed). For instance the floor of
         * 2.5 is 2.
         */

        var currentIteration = Math.floor(progress);
        /**
         * Get the current progress of the iteration by taking the remainder
         * so 2.5 is 0.5 through iteration 2
         */

        var iterationProgress = progress % 1.0;
        /**
         * If iteration progress is 1 we count that as the end
         * of the previous iteration.
         */

        if (!iterationProgress && progress >= 1) {
          iterationProgress = 1;
        }

        iterationProgress === 1 && currentIteration--;
        currentIteration = Math.min(currentIteration, repeat + 1);
        /**
         * Reverse progress if we're not running in "normal" direction
         */

        var isOddIteration = Boolean(currentIteration % 2);

        if (isOddIteration) {
          if (repeatType === "reverse") {
            iterationProgress = 1 - iterationProgress;

            if (repeatDelay) {
              iterationProgress -= repeatDelay / resolvedDuration;
            }
          } else if (repeatType === "mirror") {
            frameGenerator = mirroredGenerator;
          }
        }

        elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
      }
      /**
       * If we're in negative time, set state as the initial keyframe.
       * This prevents delay: x, duration: 0 animations from finishing
       * instantly.
       */


      var state = isInDelayPhase ? {
        done: false,
        value: keyframes[0]
      } : frameGenerator.next(elapsed);

      if (mixKeyframes) {
        state.value = mixKeyframes(state.value);
      }

      var done = state.done;

      if (!isInDelayPhase && calculatedDuration !== null) {
        done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
      }

      var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done); // TODO: The exception for inertia could be cleaner here

      if (isAnimationFinished && type !== inertia) {
        state.value = getFinalKeyframe(keyframes, this.options, finalKeyframe, this.speed);
      }

      if (onUpdate) {
        onUpdate(state.value);
      }

      if (isAnimationFinished) {
        this.finish();
      }

      return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */

  }, {
    key: "then",
    value: function then(resolve, reject) {
      return this.finished.then(resolve, reject);
    }
  }, {
    key: "duration",
    get: function get() {
      return millisecondsToSeconds(this.calculatedDuration);
    }
  }, {
    key: "time",
    get: function get() {
      return millisecondsToSeconds(this.currentTime);
    },
    set: function set(newTime) {
      var _this$driver;

      newTime = secondsToMilliseconds(newTime);
      this.currentTime = newTime;

      if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) {
        this.holdTime = newTime;
      } else if (this.driver) {
        this.startTime = this.driver.now() - newTime / this.playbackSpeed;
      }

      (_this$driver = this.driver) === null || _this$driver === void 0 ? void 0 : _this$driver.start(false);
    }
  }, {
    key: "speed",
    get: function get() {
      return this.playbackSpeed;
    },
    set: function set(newSpeed) {
      this.updateTime(time.now());
      var hasChanged = this.playbackSpeed !== newSpeed;
      this.playbackSpeed = newSpeed;

      if (hasChanged) {
        this.time = millisecondsToSeconds(this.currentTime);
      }
    }
  }, {
    key: "play",
    value: function play() {
      var _this2 = this,
          _this$options$onPlay,
          _this$options4;

      if (this.isStopped) return;
      var _this$options3 = this.options,
          _this$options3$driver = _this$options3.driver,
          driver = _this$options3$driver === void 0 ? frameloopDriver : _this$options3$driver,
          startTime = _this$options3.startTime;

      if (!this.driver) {
        this.driver = driver(function (timestamp) {
          return _this2.tick(timestamp);
        });
      }

      (_this$options$onPlay = (_this$options4 = this.options).onPlay) === null || _this$options$onPlay === void 0 ? void 0 : _this$options$onPlay.call(_this$options4);
      var now = this.driver.now();

      if (this.state === "finished") {
        this.updateFinished();
        this.startTime = now;
      } else if (this.holdTime !== null) {
        this.startTime = now - this.holdTime;
      } else if (!this.startTime) {
        this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
      }

      if (this.state === "finished" && this.speed < 0) {
        this.startTime += this.calculatedDuration;
      }

      this.holdTime = null;
      /**
       * Set playState to running only after we've used it in
       * the previous logic.
       */

      this.state = "running";
      this.driver.start();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.state = "paused";
      this.updateTime(time.now());
      this.holdTime = this.currentTime;
    }
  }, {
    key: "complete",
    value: function complete() {
      if (this.state !== "running") {
        this.play();
      }

      this.state = "finished";
      this.holdTime = null;
    }
  }, {
    key: "finish",
    value: function finish() {
      var _this$options$onCompl, _this$options5;

      this.notifyFinished();
      this.teardown();
      this.state = "finished";
      (_this$options$onCompl = (_this$options5 = this.options).onComplete) === null || _this$options$onCompl === void 0 ? void 0 : _this$options$onCompl.call(_this$options5);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this$options$onCance, _this$options6;

      this.holdTime = null;
      this.startTime = 0;
      this.tick(0);
      this.teardown();
      (_this$options$onCance = (_this$options6 = this.options).onCancel) === null || _this$options$onCance === void 0 ? void 0 : _this$options$onCance.call(_this$options6);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      this.state = "idle";
      this.stopDriver();
      this.startTime = this.holdTime = null;
      activeAnimations.mainThread--;
    }
  }, {
    key: "stopDriver",
    value: function stopDriver() {
      if (!this.driver) return;
      this.driver.stop();
      this.driver = undefined;
    }
  }, {
    key: "sample",
    value: function sample(sampleTime) {
      this.startTime = 0;
      return this.tick(sampleTime, true);
    }
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline) {
      var _this$driver2;

      if (this.options.allowFlatten) {
        this.options.type = "keyframes";
        this.options.ease = "linear";
        this.initAnimation();
      }

      (_this$driver2 = this.driver) === null || _this$driver2 === void 0 ? void 0 : _this$driver2.stop();
      return timeline.observe(this);
    }
  }]);

  return JSAnimation;
}(WithPromise); // Legacy function support


function animateValue(options) {
  return new JSAnimation(options);
}

export { JSAnimation, animateValue };